import { gql } from "@apollo/client";

export const ADD_WARDROBE_ITEMS = gql`
  mutation CreateWardrobeItems($images: [String!]!) {
    createWardrobeItems(images: $images) {
      success
      items {
        id
        imageUrl
        category {
          id
          name
        }
        item
        colors
        style
        createdAt
        updatedAt
      }
      errors {
        image
        details
        fullMessages
      }
    }
  }
`;

export const UPDATE_WARDROBE_ITEM = gql`
  mutation UpdateWardrobeItem($id: ID!, $input: WardrobeItemInput!) {
    updateWardrobeItem(id: $id, input: $input) {
      success
      outfitItem {
        id
        item
        description
        category {
          id
          name
        }
        colors
        style
        tags
        imageUrl
        createdAt
        updatedAt
      }
      errors {
        details
        fullMessages
      }
    }
  }
`;

export const UPDATE_WARDROBE_ITEM_TAGS = gql`
  mutation UpdateWardrobeItemTags($id: ID!, $tags: [String!]!) {
    updateWardrobeItemTags(id: $id, tags: $tags) {
      success
      outfitItem {
        id
        tags
      }
      errors {
        fullMessages
      }
    }
  }
`;

export const DELETE_WARDROBE_ITEM = gql`
  mutation DeleteWardrobeItem($id: ID!) {
    deleteWardrobeItem(id: $id) {
      success
      message
    }
  }
`;
